import styled, { keyframes } from 'styled-components';
import { AllieButton } from '../../../components/Buttons/Button';

const iconAnimation = keyframes`
  0%, 50%, 100% { 
    background: var(--allie-color-neutral-60); 
  }
  25%, 75% { 
    background: var(--allie-color-primary-60); 
  }
`;

export const ZapIcon = styled.div`
  color: white;
  display: flex;
  flex-basis: 20%;
  align-items: center;
  justify-content: center;
  width: 24px;
  max-width: 24px;
  height: 24px;
  border-radius: var(--allie-radius-md);
  box-shadow: 0px 0.667px 1.333px 0px rgba(16, 24, 40, 0.05);
  animation: ${iconAnimation} 3s ease-in-out infinite;
  margin-right: var(--allie-spacing-lg);
  
  & div {
    display: flex;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: var(--allie-spacing-md);
  align-items: center;
`;

export const StyledBanner = styled.div`
  width: 100%;
  margin-bottom: var(--allie-spacing-md);
  
  /* Responsive design */
  @media (max-width: 768px) {
    margin-bottom: var(--allie-spacing-sm);
  }
`;

export const StyledApplyButton = styled(AllieButton)`
  &::part(native) {
    padding: var(--allie-spacing-md);
    border-radius: var(--allie-radius-md);
  }}
`;